function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 19l2-2h14V5H4v14z",
  opacity: ".3",
  fillOpacity: ".87"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 3h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4V5c0-1.1.9-2 2-2zm2 14h14V5H4v14l2-2z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}));